import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { BASE } from './basePath';

export default function Layout() {
    const location = useLocation();
    const isAuthRoute =
        location.pathname === `${BASE}/login` ||
        location.pathname === `${BASE}/signup`;

    if (isAuthRoute) {
        return (
            <div className="h-screen w-screen bg-[#0f1419]">
                <Outlet />
            </div>
        );
    }

    return (
        <div className="flex h-screen w-screen bg-[#f5f6f4] text-[#1c2620]">
            <Sidebar />
            <main className="flex-1 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
}
